import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

/**
 * Presentational filter bar for the Reports page.
 * Owns no state: the parent (ReportCardsComponent) passes in the form group
 * and reacts to its value changes. The only event emitted is the explicit
 * search-button / enter press on the text box.
 */
@Component({
  selector: 'prism-report-filters',
  templateUrl: './report-filters.component.html',
  styleUrl: './report-filters.component.scss',
})
export class ReportFiltersComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() completionStatusOptions: { id: string; name: string }[] = [];
  @Output() search = new EventEmitter<void>();

  get searchControl(): FormControl {
    return this.form.get('search') as FormControl;
  }
  get schoolYearControl(): FormControl {
    return this.form.get('schoolYearId') as FormControl;
  }
  get organizationControl(): FormControl {
    return this.form.get('organization') as FormControl;
  }
  get completionStatusControl(): FormControl {
    return this.form.get('completionStatus') as FormControl;
  }
}
